import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import LoginForm from "../app/view/loginForm";
// import Wellcome from "../app/view/wellcomePage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import HomePage from "../components/home-page/case-homepage/case-homepage";
import SignUp from "../components/signup/sign-up";
// import CreateCase from "../components/home-page/create-case/create-case";
import Recentcases from "../components/home-page/case-homepage/cases/recentcases";
import { CreateNewCase } from "../components/home-page/create-a-new-case/create-new-case";
import Modall from "../components/home-page/modal/modal";
import { ProductDetail } from "../components/home-page/product-details/product-details";
import { ContractsWarranties } from "../components/home-page/contracts-warranties/contracts-warranties";
import { EditCase } from "../components/home-page/edit-case/edit-case";
import { MatchingCase } from "../components/home-page/matching-case/matching-case";
import { CallMeBack } from "../components/home-page/call-me-back/call-me-back";
import { InitiateChat } from "../components/home-page/initiate-chat/initiate-chat";
import { ProfileSettings } from "../components/home-page/profile-settings/profile-settings";
import { OcChat } from "../components/home-page/occhat/occhat";
import { SideNav } from "../components/home-page/shared-components/side-nav";
import CreateCase from "@components/create-case/create-case";
import { SignInFailed } from "@components/home-page/shared-components/sign-in-failed/sign-in-failed";
import Banner from "@components/shared-components/banner/banner";
import { useAppSelector } from '@store/hooks';
import BulkUploadTabs from "@components/home-page/bulk-upload/bulk-upload-tabs";
import { AdminRole } from "utils";


const Login = () => {
  const location = useLocation();
  const shouldRenderSideNav = !location.pathname.includes("signup");
  const isOpen = useAppSelector((state) => state.banner.isOpen);
  return (
    <>
      {shouldRenderSideNav && <SideNav />}

      {isOpen && (<Banner />)}

      <Routes>
        <Route path="/signup" element={<SignUp />} />
        <Route path="/" element={<CreateNewCase />} />
        <Route path="/create-case" element={<CreateCase />} />
        <Route path="/my-cases" element={<HomePage />} />
        <Route path="/product-details" element={<ProductDetail />} />
        <Route path="/contract-warranties" element={<ContractsWarranties />} />
        <Route path="/edit-case" element={<EditCase />} />
        <Route path="/profile" element={<ProfileSettings />} />
        <Route path="/initiate-chat" element={<InitiateChat />} />
        <Route path="/initiate-chat/occhat" element={<OcChat />} />
        <Route path="/case-match" element={<MatchingCase />} />
        <Route path="/edit-case/call-me-back" element={<CallMeBack />} />
        {AdminRole && (
        <Route path="/bulk-upload" element={<BulkUploadTabs />} />
        )}
      </Routes>
      <ToastContainer />
    </>
  );
};

export default Login;
